import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { IngresoActivoFijoFuncionario } from 'src/app/models/RegistroActivoFijoFuncionario.model';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/shared/services/util.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { ConsultaFuncionarioDTO } from 'src/app/models/consulta-funcionario.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import * as moment from 'moment';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';

@Component({
  selector: 'app-consulta-funcionarios',
  templateUrl: './consulta-funcionario.component.html',
  styleUrls: ['./consulta-funcionario.component.scss']
})
export class ConsultaFuncionarioComponent implements OnInit {

  listaFuncionarios: ConsultaFuncionarioDTO[];
  urlFTP: string;
  filtroNombre: string;
  filtroFecha: string;
  rolUsuario: string;
  puedeCrear = true;
  listaMeses: any[] = [];
  p: any;

  constructor(
    private globalService: GlobalService, private urlService: UrlService,
    private alertService: AlertService, private spinner: NgxSpinnerService,
    private router: Router, private utils: UtilService) {
    this.urlFTP = sessionStorage.getItem(ConstantesService.FTP_SESSSION);
    this.rolUsuario = sessionStorage.getItem(ConstantesService.ROL_SESSION);

    this.puedeCrear = !(DominiosService.ROL_ADMINISTRADOR_TEC === this.rolUsuario);
  }

  ngOnInit() {
    this.listaMeses = [];
    this.consultarFuncionariosConRegistro();
    this.llenarListaMeses();
  }

  /**
   * redirecciona a pantalla de registro de funcionario
   */
  realizarRegistro(event: any) {
    this.router.navigate(['/main/administrar-funcionarios/registro']);
  }

    /**
   * redirecciona a pantalla de carga masiva
   */
     cargaMasiva(event: any) {
      this.router.navigate(['/main/registro-carga-inventario']);
    }

  editarRegistro(obj) {
    this.globalService.zonaCompartida[VariablesZonaCompartida.DATOS_FUNCIONARIO] = {
      numDocumento: obj.numeroDocumento,
      tipoDocumento: obj.tipoDocumento
    };
    this.router.navigate(['/main/administrar-funcionarios/registro']);
  }

  /**
   * Metodo que verifica si el campo filtro se ecuentra con un nombre o tipo de documento
   * para realizar el llamado de la consulta repecto a dicho filtro
   */
  buscarPorFiltro() {
    if ((!this.utils.validarCamposObligatorios(this.filtroNombre)
      && !this.utils.validarCamposObligatorios(this.filtroFecha))
      || (!this.utils.validarCamposObligatorios(this.filtroNombre)
      && this.utils.validarCamposObligatorios(this.filtroFecha))
      ) {
        this.consultarFuncionariosConRegistro();
    } else {
      if (this.validarCaracteresFiltro(this.filtroNombre)) {
        this.consultarFuncionariosConRegistro(this.filtroNombre, null);
      } else {
        this.consultarFuncionariosConRegistro(null, this.filtroNombre);
      }
    }
  }

  /**
   * Peticion de consulta de funcionarios vinculados
   * @param numeroDocumento contiene el numero ingresado en el campo filtro para realizar la consulta
   * @param nombre contiene el nombre ingresado en el campo filtro para realizar la consultar
   */
  consultarFuncionariosConRegistro(numeroDocumento?: string, nombre?: string) {
    this.listaFuncionarios = [];
    this.spinner.show();
    const serviceProvider = 'ConsultaFuncionario';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    if (numeroDocumento) {
      queryParams.push(['numeroDocumento', numeroDocumento]);
    }
    if (nombre) {
      queryParams.push(['nombre', nombre]);
    }
    if (!isNaN(Date.parse(this.filtroFecha))) {
      queryParams.push(['fecha', Date.parse(this.filtroFecha).toString()]);
    }
    const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_TRANS);
    this.globalService.getGenerico(url)
      .subscribe((dataFuncionario: ConsultaFuncionarioDTO[]) => {
        if (dataFuncionario.length > 0) {
          this.listaFuncionarios = dataFuncionario;
          this.listaFuncionarios.forEach(funcionario => {
            funcionario.urlFoto = this.obtenerUrlFoto(funcionario.urlFotoFuncionario);
          });
        } else if (numeroDocumento || nombre || !isNaN(Date.parse(this.filtroFecha))) {
          this.alertService.generateAlertError('No se encuentran funcionarios con los criterios seleccionados', '');
        }
        this.spinner.hide();
      }, error => {
        console.log(error);
        this.cathException(error.error.message);
      });
  }

  /**
   * Metodo encargado de colocar la foto de la persona o en dicha caso que no tenga
   * coloca la foto por defecto
   */
  public obtenerUrlFoto(url: string): string {
    if (this.urlFTP && this.urlFTP !== '' && url) {
      return this.urlFTP + url;
    } else {
      return 'assets/img/user-male-icon.png';
    }
  }

  /**
   * Metodo que valida si filtro ingresado corresponde a un
   * numero de documento o nombre del funcionario
   * @param valor filtro que la persona ingreso
   */
  validarCaracteresFiltro(valor: string): boolean {
    const numeros = '0123456789';
    for (let i = 0; i < valor.length; i++) {
      if (numeros.indexOf(valor.charAt(i), 0) !== -1) {
        return true;
      }
    }

    return false;
  }

  /**
   * Método de control de Excepciones
   * @param error mensaje saliente respecto al error ocurrido
   */
  cathException(error) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }

  llenarListaMeses() {
    let fechaActual = new Date();
    fechaActual.setHours(0, 0, 0, 0);
    fechaActual.setDate(1);

    for (let i = 0 ; i < 12; i++) {
      const mesFiltro: any = {};
      mesFiltro.fecha = moment(fechaActual).subtract(30, 'days').toDate();
      mesFiltro.texto = ConstantesService.MESES[mesFiltro.fecha.getMonth()] +
        ' - ' + mesFiltro.fecha.getFullYear();
      this.listaMeses.push(mesFiltro);
      fechaActual = mesFiltro.fecha;
    }
  }
}
